import React, { Component } from "react";
import IPSDataService from "../services/ips.service";
import { Modal, Form, Button} from "react-bootstrap";
import Captcha from "demos-react-captcha";

export default class DemoAccess extends Component {
    constructor(props) {
      super(props);

      this.onChangeEmail = this.onChangeEmail.bind(this);
      this.onChangePhone = this.onChangePhone.bind(this);
      this.onChangeFirstName = this.onChangeFirstName.bind(this);
      this.onChangeExtendRequestMessage = this.onChangeExtendRequestMessage.bind(this);
      this.onChangePassword = this.onChangePassword.bind(this);
      this.onChangeConfirmPassword = this.onChangeConfirmPassword.bind(this);
      this.onChangeloginPassword = this.onChangeloginPassword.bind(this);
      this.onChangeloginEmail = this.onChangeloginEmail.bind(this);
      this.onChangeCaptcha = this.onChangeCaptcha.bind(this);
      this.onChangeCaptchaSignup = this.onChangeCaptchaSignup.bind(this);
      this.onChangePolicyCheck = this.onChangePolicyCheck.bind(this);
      this.onChangeContactTitle = this.onChangeContactTitle.bind(this);
      this.onChangeContactEmail = this.onChangeContactEmail.bind(this);
      this.onChangeContactPhone = this.onChangeContactPhone.bind(this);
      this.onChangeContactCountry = this.onChangeContactCountry.bind(this);
      this.onChangeContactMessage = this.onChangeContactMessage.bind(this);
      this.saveMessage = this.saveMessage.bind(this);
      this.onChangeContactCaptcha = this.onChangeContactCaptcha.bind(this);
      this.state = {
          fname: '',
          loginPassword:'',
          loginEmail:"",
          lname: "",
          email: "",
          phoneno:"",
          password:"",
          confirmpassword:"",
          contact:"",
          PasswordSent:false,
          extendRequest:false,
          extendRequestMessage:'',
          message: "",
          messageType: "",
          loginmessage: "",
          submitted: false,
          captchacheck:false,
          captchachecksignup:false,
          published: false,
          showModalTandC: false,
          message: "",
          policycheck: true,

          contacttitle: "",
          contactemail:"",
          contactphone:"",
          contactcountry: "Saudi Arabia",
          contactsubmitted: false,
          contactMessage: '',
          contactcaptchacheck:false,
          activeTab:'login'
      };
    }

    onChangeFirstName(e)
    {
     this.setState({
       fname: e.target.value
     });
   }

   onChangeCaptcha(value) {
    this.setState({
      captchacheck: value
    });
  }

  onChangeCaptchaSignup(value) {
    this.setState({
      captchachecksignup: value
    });
  }

   onChangeloginPassword(e)
    {
     this.setState({
        loginPassword: e.target.value
     });
   }

   onChangeloginEmail(e)
    {
     this.setState({
        loginEmail: e.target.value
     });
   }

  
   
   onChangePassword(e)
    {
     this.setState({
       password: e.target.value
     });
   }

   onChangePolicyCheck(e) {

    this.setState({policycheck: !this.state.policycheck})
  }
   
 
   onChangeConfirmPassword(e)
    {
     this.setState({
       confirmpassword: e.target.value
     });
   }


    onChangeEmail(e) 
    {
      this.setState({
        email: e.target.value
      });
    }

    onChangePhone(e) 
    { 

      //alert(e.target.value);
      this.setState({
        phoneno: e.target.value
      });
    }

    onChangeExtendRequestMessage(e) 
    {
      this.setState({
        extendRequestMessage: e.target.value
      });
    }
  
    openModalTandC()
    {    
        
          this.setState({
          showModalTandC: true,
          });
       
    }

    closeModalTandC()
    {    
        
          this.setState({
          showModalTandC: false
          });
       
    }


    handleSubmit()
    {   
        this.setState({
                        
          message: ""
        
            });

            if(this.state.email=='' || this.state.phoneno=='' || this.state.fname=='' || this.state.password==''  || this.state.confirmpassword=='')
            {
    
              this.setState({
                            
                message: 'Please fill form,(*) are mandatory',
              
                  });
                  return false;
            }

            if( this.state.password!=this.state.confirmpassword)
            {
    
              this.setState({
                            
                message: 'Passwords mismatched, please retype password',
              
                  });
                  return false;
            }
     
          
   
        var data = {
           email: this.state.email,
           fname: this.state.fname,
          // phoneno: this.state.phoneno,
          phoneno: document.getElementById('full_number').value,
           password: this.state.password,
          
        };
        const reg = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
        if(this.state.email!=="")
        {
           if (reg.test(this.state.email) === false){
            this.setState({
                        
              message: 'Invalid email address',
            
                });
                return false;
           }
   
        }

        if(this.state.captchachecksignup==false)
        {
         this.setState({
                           
          message: 'Invalid captcha',
         
             });
             return false;
        }

     
       
        IPSDataService.signupDemoAccess(data)
           .then(response => 
              {
                console.log(response.data);
                let messageTypeTemp="";
                if(response.data=="Please check your email inbox for verification")
                {
                  messageTypeTemp="success";
                }
                else
                {
                  messageTypeTemp="error";
                }
                
                    this.setState({
                        
                      message: response.data,
                      messageType:messageTypeTemp
                    
                        });

                        

                

               
               
               })
   
           .catch(e => 
              {  console.log(e);
               });
        
   
    }
    // //////////////////////
    forgotPasword(e)
    {   
      this.setState({
                        
        message: ""
      
          });

         if(this.state.loginEmail=='')
         {
          
          this.setState({
                        
            loginmessage: 'Please provide valid email address',
          
              });
              return false;

         }

         var data = {
          username: this.state.loginEmail,
         
       };

         IPSDataService.forgetpassword(data)
         .then(response => 
            {
              
              
              
              this.setState({
                        
                loginmessage: response.data.message
              
                  });
              
             
             })
 
         .catch(e => 
            {  console.log(e);
             });

    }

    // ///////////////////
    
    handleLogin()
 {
  this.setState({
                        
    loginmessage: ""
  
      });

      

      if(this.state.loginEmail=="" || this.state.loginPassword=='')
      {    
 
        this.setState({
                      
          loginmessage: 'Please fill form,(*) are mandatory',
        
            });
            return false;
      }
     
    
     const reg = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
     if(this.state.loginEmail!=="")
     {
        if (reg.test(this.state.loginEmail) === false){
          this.setState({
                        
            loginmessage: 'Invalid email address',
          
              });
              return false;
        }

     }

     

     if(this.state.captchacheck==false)
     {
      this.setState({
                        
        loginmessage: 'Invalid captcha',
      
          });
          return false;
     }

  
     
     var data = {
      email: this.state.loginEmail,
      password: this.state.loginPassword,
     
   };
     
     
     IPSDataService.LoginDemoAccess(data)
        .then(response => 
           {
             console.log(response.data);
             
             if(response.data.login)
             {
                
              sessionStorage.setItem('DemoUserEmail', this.state.loginEmail);
              sessionStorage.setItem('DemoUserName', response.data.name);
              sessionStorage.setItem('DemoUserPassword', this.state.loginPassword);
              sessionStorage.setItem('DemoUserLogin', 'true');
              sessionStorage.setItem('url', JSON.stringify(response.data.url));
              localStorage.setItem('url', JSON.stringify(response.data.url));
                 window.location.replace(response.data.url);
             }
             else if(response.data.message=="Exired token")
             {
                
              this.setState({
                        
                loginmessage: "We are so sorry to inform you that your access to the portfolio reporting platform has expired.<br/><br/>Please contact cs@watarpartners.com for more assistance or request admin to extend your demo access.",
                extendRequest:true
                  });
                
             }

             else 
             {
                
              this.setState({
                        
                loginmessage: response.data.message
              
                  });
                
             }
             
            
            })

        .catch(e => 
           {  console.log(e);
            });
     

 }

 componentDidMount() {

  const UrlAfter_ = window.location.href.substring(window.location.href.indexOf('demoaccess') );
     
      var splitStr= UrlAfter_.split('?')
      var activeTab =splitStr[1];

     if(activeTab=="login" || activeTab=="signup" || activeTab=="contact")
     {

      this.setState({
                        
        activeTab: activeTab
      
          });
        }
      
  
}



 handleExtendRequest()
 {
  this.setState({
                        
    loginmessage: ""
  
      });

      

      if(this.state.loginEmail=="" || this.state.loginPassword=='')
      {    
 
        this.setState({
                      
          loginmessage: 'Please fill form,(*) are mandatory',
        
            });
            return false;
      }
     
    
     const reg = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
     if(this.state.loginEmail!=="")
     {
        if (reg.test(this.state.loginEmail) === false){
          this.setState({
                        
            loginmessage: 'Invalid email address',
          
              });
              return false;
        }

     }

     

     if(this.state.captchacheck==false)
     {
      this.setState({
                        
        loginmessage: 'Invalid captcha',
      
          });
          return false;
     }

  
     
     var data = {
      email: this.state.loginEmail,
      password: this.state.loginPassword,
      message:this.state.extendRequestMessage
     
   };
     
     
     IPSDataService.ExtendRequestDemoAccess(data)
        .then(response => 
           {
             console.log(response.data);
             
             
             
                
              this.setState({
                        
                loginmessage: response.data.message,
                extendRequest:false
              
                  });
                
             
             
            
            })

        .catch(e => 
           {  console.log(e);
            });
     

 }


 onChangeContactCaptcha(value) {
  this.setState({
    contactcaptchacheck: value
  });
}

onChangeContactTitle(e) {
    this.setState({
      contacttitle: e.target.value
    });
  }

  onChangeContactEmail(e) {
    this.setState({
      contactemail: e.target.value
    });
  }

  onChangeContactPhone(e) {
    this.setState({
      contactphone: e.target.value
    });
  }

  onChangeContactCountry(e) {
    this.setState({
      contactcountry: e.target.value
    });
  }

  onChangeContactMessage(e) {
    this.setState({
      contactMessage: e.target.value
    });
  }


  saveMessage() {

    document.getElementById("successMessage").innerHTML= '';
    document.getElementById("errorMessage").innerHTML= '';
      var data = {
        title: this.state.contacttitle,
        email: this.state.contactemail,
        phoneno: this.state.contactphone,
        country: this.state.contactcountry,
        message: this.state.contactMessage,
        type:'demo_access'
      };

      const reg = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
      if(this.state.contactemail!="")
      {
         if (reg.test(this.state.contactemail) === false){
             
             document.getElementById("errorMessage").innerHTML= "Invalid email address.";
             return false;
         }
        }

        if (this.state.contactcaptchacheck != true){
      
          document.getElementById("errorMessage").innerHTML= "Please fill valid captcha";
          return false;
      }
         
  
      IPSDataService.sendmessage(data)
        .then(response => {
          this.setState({
            contacttitle: response.data.title,
            contactemail: response.data.email,
            contactsubmitted: true
          });
          //document.getElementById("successMessage").innerHTML= 'Your message has been sent to HR.';
          console.log(response.data);
        })
        .catch(e => {
          document.getElementById("errorMessage").innerHTML= e.response.data.message+"Please fill all fields,(*) are mandatory";
          console.log(e);
        });
    }



    render() {
  const countryList = ["Afghanistan",	"Albania",	"Algeria",	"American Samoa",	"Andorra",	"Angola",	"Anguilla",	"Antarctica",	"Antigua and Barbuda",	"Argentina",	"Armenia",	"Aruba",	"Australia",	"Austria",	"Azerbaijan",	"Bahamas",	"Bahrain",	"Bangladesh",	"Barbados",	"Belarus",	"Belgium",	"Belize",	"Benin",	"Bermuda",	"Bhutan",	"Bolivia (Plurinational State of)",	"Bonaire, Sint Eustatius and Saba",	"Bosnia and Herzegovina",	"Botswana",	"Bouvet Island",	"Brazil",	"British Indian Ocean Territory",	"Brunei Darussalam",	"Bulgaria",	"Burkina Faso",	"Burundi",	"Cabo Verde",	"Cambodia",	"Cameroon",	"Canada",	"Cayman Islands",	"Central African Republic",	"Chad",	"Chile",	"China",	"Christmas Island",	"Cocos (Keeling) Islands",	"Colombia",	"Comoros",	"Congo (the Democratic Republic of the)",	"Congo",	"Cook Islands",	"Costa Rica",	"Croatia",	"Cuba",	"Curaçao",	"Cyprus",	"Czechia",	"Côte d'Ivoire",	"Denmark",	"Djibouti",	"Dominica",	"Dominican Republic",	"Ecuador",	"Egypt",	"El Salvador",	"Equatorial Guinea",	"Eritrea",	"Estonia",	"Eswatini",	"Ethiopia",	"Falkland Islands [Malvinas]",	"Faroe Islands",	"Fiji",	"Finland",	"France",	"French Guiana",	"French Polynesia",	"French Southern Territories",	"Gabon",	"Gambia",	"Georgia",	"Germany",	"Ghana",	"Gibraltar",	"Greece",	"Greenland",	"Grenada",	"Guadeloupe",	"Guam",	"Guatemala",	"Guernsey",	"Guinea",	"Guinea-Bissau",	"Guyana",	"Haiti",	"Heard Island and McDonald Islands",	"Holy See",	"Honduras",	"Hong Kong",	"Hungary",	"Iceland",	"India",	"Indonesia",	"Iran (Islamic Republic of)",	"Iraq",	"Ireland",	"Isle of Man",	"Israel",	"Italy",	"Jamaica",	"Japan",	"Jersey",	"Jordan",	"Kazakhstan",	"Kenya",	"Kiribati",	"Korea (the Democratic People's Republic of)",	"Korea (the Republic of)",	"Kuwait",	"Kyrgyzstan",	"Lao People's Democratic Republic",	"Latvia",	"Lebanon",	"Lesotho",	"Liberia",	"Libya",	"Liechtenstein",	"Lithuania",	"Luxembourg",	"Macao",	"Madagascar",	"Malawi",	"Malaysia",	"Maldives",	"Mali",	"Malta",	"Marshall Islands",	"Martinique",	"Mauritania",	"Mauritius",	"Mayotte",	"Mexico",	"Micronesia (Federated States of)",	"Moldova (the Republic of)",	"Monaco",	"Mongolia",	"Montenegro",	"Montserrat",	"Morocco",	"Mozambique",	"Myanmar",	"Namibia",	"Nauru",	"Nepal",	"Netherlands",	"New Caledonia",	"New Zealand",	"Nicaragua",	"Niger",	"Nigeria",	"Niue",	"Norfolk Island",	"Northern Mariana Islands",	"Norway",	"Oman",	"Pakistan",	"Palau",	"Palestine, State of",	"Panama",	"Papua New Guinea",	"Paraguay",	"Peru",	"Philippines",	"Pitcairn",	"Poland",	"Portugal",	"Puerto Rico",	"Qatar",	"Republic of North Macedonia",	"Romania",	"Russian Federation",	"Rwanda",	"Réunion",	"Saint Barthélemy",	"Saint Helena, Ascension and Tristan da Cunha",	"Saint Kitts and Nevis",	"Saint Lucia",	"Saint Martin (French part)",	"Saint Pierre and Miquelon",	"Saint Vincent and the Grenadines",	"Samoa",	"San Marino",	"Sao Tome and Principe",	"Saudi Arabia",	"Senegal",	"Serbia",	"Seychelles",	"Sierra Leone",	"Singapore",	"Sint Maarten (Dutch part)",	"Slovakia",	"Slovenia",	"Solomon Islands",	"Somalia",	"South Africa",	"South Georgia and the South Sandwich Islands",	"South Sudan",	"Spain",	"Sri Lanka",	"Sudan",	"Suriname",	"Svalbard and Jan Mayen",	"Sweden",	"Switzerland",	"Syrian Arab Republic",	"Taiwan",	"Tajikistan",	"Tanzania, United Republic of",	"Thailand",	"Timor-Leste",	"Togo",	"Tokelau",	"Tonga",	"Trinidad and Tobago",	"Tunisia",	"Turkey",	"Turkmenistan",	"Turks and Caicos Islands",	"Tuvalu",	"Uganda",	"Ukraine",	"United Arab Emirates",	"United Kingdom of Great Britain and Northern Ireland",	"United States Minor Outlying Islands",	"United States of America",	"Uruguay",	"Uzbekistan",	"Vanuatu",	"Venezuela (Bolivarian Republic of)",	"Viet Nam",	"Virgin Islands (British)",	"Virgin Islands (U.S.)",	"Wallis and Futuna",	"Western Sahara",	"Yemen",	"Zambia",	"Zimbabwe",	"Åland Islands"];
  return (

    
   
    
<>

<div className="clearfix"></div>
      


                                


                                 <div class="container">
         
         <div class="row" >

         

         <div class="col-md-12 col-lg-12 col-sm-12 col-xs-12">
          
                  <div class="loginbox">
                  <div style={{textAlign:'center'}}>
			<a href={process.env.REACT_APP_WATAR_URL}><img src="/assets/watar_logo.svg" style={{
objectFit: 'contain',
objectPosition: 'center center'}}/></a>
		</div>
                   <div class="row" style={{marginTop:'30px'}}>

                      <div class="col-md-6 col-lg-6 col-sm-6 col-xs-12">

                      <div class="well">
    <ul class="nav nav-tabs">
      <li class={this.state.activeTab=="signup"? "active":""} style={{width:'33.33%'}} ><a style={{borderRadius:'0px', width:'100%'}} class="btn btn-large btn-secondary btn-lg" href="#signup" data-toggle="tab">Signup</a></li> 
      <li class={this.state.activeTab=="login"? "active":""} style={{width:'33.33%'}} ><a style={{borderRadius:'0px',borderLeft:'4px solid #FF7F50', width:'100%'}} class="btn btn-large btn-secondary btn-lg" href="#signin"  data-toggle="tab">Signin</a></li> 
      <li class={this.state.activeTab=="contact"? "active":""} style={{width:'33.33%'}} ><a style={{borderRadius:'0px',borderLeft:'4px solid #FF7F50', width:'100%'}} class="btn btn-large btn-secondary btn-lg" href="#contact"  data-toggle="tab">Contact</a></li>
    </ul>


    <div id="myTabContent" class="tab-content">

      <div class={this.state.activeTab=="signup"? "tab-pane active":"tab-pane fade"}  id="signup">
      <h3 class="leave_us" style={{textAlign:'center',fontSize:'1.25rem'}}><b>Portfolio Reporting Demonstration Registration</b></h3>
                         <hr style={{borderTop:'4px dotted rgba(0,0,0,.1)', marginTop:'0px'}}/> 
      
     

{this.state.messageType!="success"?(
 <Form>



 <Form.Group className="mb-3">
     <Form.Label>Full Name*</Form.Label>
     <Form.Control
       type="text"
       className="form-control" value={this.state.fname}  onChange={this.onChangeFirstName} id="firstName" placeholder="Your name"
       autoFocus
     />
   </Form.Group>


   <Form.Group className="mb-3">

     <Form.Label>Email Address*</Form.Label>
     <Form.Control
       type="email"
       onChange={this.onChangeEmail} value={this.state.email} className="form-control" id="inputEmail" placeholder="Your email address"
       
     />
     
     
   </Form.Group>

   <Form.Group className="mb-3">
          <label>Phone*</label> 
                      <input id="phone"
          required
         
          onChange={this.onChangePhone}
          name="phone"  className="form-control"  type="tel" />
            <input type="hidden"  id="full_number" />
                     

                      </Form.Group>

                      <div id="error-msg" style={{color:'red'}}></div>

                      <div id="valid-msg" style={{color:'green'}}></div>

                     

   <Form.Group className="mb-3">
<Form.Label>Password*</Form.Label>
<Form.Control type="password" placeholder="Type Password" 

className="form-control" value={this.state.password}  onChange={this.onChangePassword} id="password" 
/>

     
</Form.Group>


<Form.Group className="mb-3">
<Form.Label>Re-type Password*</Form.Label>
<Form.Control type="password" placeholder="Re-type Password" 

className="form-control" value={this.state.confirmpassword}  onChange={this.onChangeConfirmPassword} id="password" 
/>
</Form.Group>

<Form.Group className="mb-3">

     <Captcha onChange={this.onChangeCaptchaSignup} value={this.state.val} placeholder="Enter captcha value" />
     

     
</Form.Group>

<div className="form-check" style={{paddingLeft:'0px'}}>
 <input style={{marginLeft:'0px'}} onChange={this.onChangePolicyCheck} defaultChecked={this.state.policycheck} type="checkbox" name="policycheck" className="form-check-input"  id="policycheck"/ >
 <label className="form-check-label" htmlFor="policycheck"   style={{display:'inline'}}>I agree with </label><a onClick={e => this.openModalTandC()} style={{color:"#0078D4"}} target="_blank" >Terms & Conditions</a> 
 <p style={{color:'red', paddingLeft:'3px'}}>{ this.state.policycheck==false? "Please click agree with Terms & Conditions":""}</p>
</div>

</Form>):(<p style={{width:'100%',textAlign:'center',color:'green'}}><i class="fa fa-check-circle fa-3x"></i></p>)
}

<p style={{textAlign:'center', color:this.state.messageType=="success"?'green':'red'}}>{this.state.message}</p>


 


{this.state.messageType!="success"?(    
<Button style={{width:'80%',margin:'0px 10%'}} variant="secondary" disabled={ this.state.policycheck==false?"disabled":""}  onClick={this.handleSubmit.bind(this)}>
   Submit
 </Button>):""}       

 

      </div>



      <div class={this.state.activeTab=="login"? "tab-pane active":"tab-pane fade"} id="signin">
      
                         <div>
                         <h3 class="leave_us" style={{textAlign:'center'}}><b>Login to your account</b></h3>
                         <hr style={{borderTop:'4px dotted rgba(0,0,0,.1)', marginTop:'0px'}}/> 
            <div class="row">	
               
                <div class="form-group col-md-12">
                <label>Email*</label>
                <input 
               
               type="email"
               placeholder="Enter your email"

               className="form-control" value={this.state.loginEmail}  onChange={this.onChangeloginEmail} id="loginEmail" 
               autocomplete="off"
               />
          </div>

          <div class="form-group col-md-12">
          <label>Password*</label>
          <input 
                type="password" placeholder="Enter your password"
    
                className="form-control" value={this.state.loginPassword}  onChange={this.onChangeloginPassword} id="loginPassword"
                />

          </div>

        



                     <div className="form-group col-md-12 col-xs-12">        
              <Captcha onChange={this.onChangeCaptcha} value={this.state.val} placeholder="Enter captcha value" />
              </div>

                     <div class="form-group col-md-12">
                     <button class="btn btn-secondary" style={{width:'80%',margin:'0px 10%'}}
             onClick={this.handleLogin.bind(this)}
            >&nbsp;Login&nbsp;</button>
                <br/>
                <p style={{color:'red',fontSize:'13px'}} dangerouslySetInnerHTML={{__html:this.state.loginmessage}}></p>

                {this.state.extendRequest==true?
                (<div  style={{border:'2px solid #E5E5E5',borderRadius:'10px',padding:'5px'}}>       
                <div class="row" >	
               
                <div class="form-group col-md-12">
                <label>Demo Access Extension Request</label>
                <textarea 
               
               
               placeholder="Enter your message"

               className="form-control" value={this.state.extendRequestMessage}  onChange={this.onChangeExtendRequestMessage}  
               autocomplete="off"
               ></textarea>
          </div>

          <div class="form-group col-md-12">
          <button style={{width:'80%',margin:'0px 10%'}} class="btn btn-secondary" onClick={this.handleExtendRequest.bind(this)}>
          Send</button>
          </div>
          </div></div>):
                (<div></div>)}
                

                </div>

                <div class="col-md-5">
                
            <a  style={{cursor:'pointer', color:'#007bff'}}     onClick={this.forgotPasword.bind(this)}> Forgot Password?
                </a> <br/>
            
            
        

                    
                    <div class="mt-20 alert-msg"></div>
                </div>


              
            </div>
            </div>

      </div>




      <div class={this.state.activeTab=="contact"? "tab-pane active":"tab-pane fade"} id="contact">

<h3 class="leave_us" style={{textAlign:'center'}}><b>Contact Us</b></h3>
                         <hr style={{borderTop:'4px dotted rgba(0,0,0,.1)', marginTop:'0px'}}/> 

      <div className="row">
      


        {this.state.contactsubmitted ? (
          
          
					<div className="col-md-12">
          
             
                           <div className="" style={{width:'auto', textAlign: 'center', color:'#67707D'}}>
                              
                              <img src="/img/success.png"></img>
                              <h4>Your message was sent successfully</h4>
                              <h4>Our team will get back to you</h4>
                           </div>
                        </div>

                        
                        
            
            
          
        ) :  (
                    
                      <div className="">
         
              <div class="form-group col-md-12">
          <label>Name*</label>
                      <input name="title" id="title"
          required
          value={this.state.contacttitle}
          onChange={this.onChangeContactTitle}
           placeholder="Enter your name" onfocus="this.placeholder = ''" onBlur="this.placeholder = 'Enter your name'" className="form-control"  type="text" />
                      </div>
                  

                      <div class="form-group col-md-12">
          <label>Email*</label>
                  <input name="email" id="email"
          required
          value={this.state.contactemail}
          onChange={this.onChangeContactEmail}
           placeholder="Enter email address" pattern="[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{1,63}$" onfocus="this.placeholder = ''" onBlur="this.placeholder = 'Enter email address'" className="form-control"  type="email" />
                      </div>
                  
              

              
                      <div class="form-group col-md-12">
          <label>Country*</label>
                        <select defaultValue='Saudi Arabia' className="form-control" id="country" onChange={this.onChangeContactCountry}  required name="country">
                          <option disabled selected>Select Country</option>
                        {countryList.map((List, index) => (
                     <option value={List} >{List}</option>
                     ))}
        
                              
                            </select>
                      </div>
                  
                      <div class="form-group col-md-12">
          <label>Phone*</label>
                      <input id="subject"
          required
         
          onChange={this.onChangeContactPhone}
          name="subject" placeholder="Enter phone number" onfocus="this.placeholder = ''" onBlur="this.placeholder = 'Enter your phone number'" className="form-control"  type="text" />
                      </div>



                      <div class="form-group col-md-12">
                <label>Message</label>
                <textarea 
               
               
               placeholder="Enter your message"

               className="form-control" value={this.state.contactMessage}  onChange={this.onChangeContactMessage}  
               autocomplete="off"
               ></textarea>
          </div>
                  
              

              

             

             

              <div className="form-group col-md-12 col-xs-12">        
              <Captcha  onChange={this.onChangeContactCaptcha} defaultValue={this.state.val} placeholder="Enter captcha value" />
              </div>

                  
              
            
          
          <div className="col-md-12">
                      <div className="form-group">
                          <button style={{width:'80%',margin:'0px 10%'}} onClick={this.saveMessage} className="btn" id="submit-button">Submit</button>
                      </div>
                  </div>
           
          <p style={{color:'green'}} id="successMessage"></p>
                    <p style={{color:'red'}} id="errorMessage"></p>
      </div>
                    
                    
                   
               
)}



        
        
      </div>

      </div>





  </div>
  </div>

                      

                      </div>

                      <div class="vl"></div>

                      <div class="col-md-5 col-lg-5 col-sm-5 col-xs-12">
                        <img style={{marginTop:'0px', width:'100%'}}  class="contact-img" src="/img/account_img_2.png" />

                   
                     </div>
                   </div>

                </div>
                </div>
            
          

          

          </div>
        </div>
    
    
      

{/* /////////////////////////////////////////////////////////////// */}



      


      <Modal id="TanC-modal" size="lg" dialogClassName="modal-90w" show={this.state.showModalTandC} backdrop="static" onHide={this.closeModalTandC.bind(this)}>
               <Modal.Header>
                  <Modal.Title style={{width:'95%'}}>
                     <div className="modal-heading">Terms & Conditions</div>
                  </Modal.Title>
                  <a style={{width:'5%'}} onClick={this.closeModalTandC.bind(this)}><i className="fa fa-times"></i></a> 
               </Modal.Header>
               <Modal.Body style={{background:'white'}}>

               <iframe title="Demo - Access" class='report-frame' src={'https://cs.watarpartners.com/termsandconditions.html'} frameborder="0" allowFullScreen="true"
></iframe>
                   {/*
                     <div className="modal-dialog modal-dialog-centered">
                        <div className="modal-content">
                           <div className="modal-body">
                              <div className="">
                                 <div className="col-md-12">
                                 <b>Risk Profile Questionnaire—Terms and conditions of use</b><br/>
How you allocate your capital amongst different asset classes may be the most important factor in determining the long-term return and volatility of your portfolio. 
The Risk Profile Questionnaire makes asset allocation suggestions based on information you enter about your investment objectives and experience, time horizon, risk tolerance, and financial situation. As your financial circumstances or goals change, it may be helpful to complete the questionnaire again and to reallocate the investments in your portfolio. The Risk Profile Questionnaire is provided for educational and/or informational purposes only and does not constitute investment advice.

To use the Risk Profile Questionnaire, you should read the limitations and accept our terms and conditions of use.<br/><br/>

<b>Consent to electronic delivery and terms and conditions of use</b><br/>
The Risk Profile Questionnaire is designed to help you decide how to allocate your assets among different asset classes (public & private stocks, bonds, and short-term reserves). You are under no obligation to accept the suggested allocations provided by this questionnaire.
In applying a particular asset allocation to your situation, you should consider your other assets and sources of income (e.g., equity in a home, IRA investments, savings accounts, and interest in other qualified and non-qualified plans) in addition to your interests in this account.
The allocations provided are based on generally accepted investment principles. There is no guarantee, however, that any particular asset allocation or mix of funds will meet your investment objectives. All investments involve risks, and fluctuations in the financial markets and other factors may cause declines in the value of your account. You should carefully consider all of your options before investing.
The Risk Profile Questionnaire is provided to you free of charge. It does not provide comprehensive investment or financial advice. Watar Partners or its affiliates are not responsible for reviewing your financial situation or updating the suggestions contained herein.

<br/><br/>By clicking I agree, you agree to the terms outlined on this page.<br/><br/>


<b>Duration of election and consent</b><br/>
Your consent applies only to this particular request. If you request additional information, you may be required to consent to electronic delivery again.<br/><br/>



<b>Costs and risks</b><br/>
Watar Partners does not charge you a fee to use our website, but you could incur expenses from an Internet service provider when you access information online. Also, be aware that your Internet service provider may occasionally experience system failure and hyperlinks to documents may not function properly.<br/><br/>

<b>Risk Profile Questionnaire—Limitations</b><br/>
Caveats on the questionnaire's ability to provide financial forecasts
As you use the questionnaire, keep the following limitations in mind:<br/>
The suggested asset allocations within the questionnaire depend on subjective factors such as your risk tolerance and financial situation. For this reason, you should view them only as broad guidelines for how you might consider investing your savings. It's important to review historical returns of short-term investments, bonds, and stocks carefully over various holding periods to see if you can accept the level of risk in a given investment mix.<br/>
The asset allocations are limited to various broad classes of investments and do not include all potential asset classes.<br/>
The investment returns represented in the questionnaire are based on historical index returns from a pre-selected time period and are not intended to indicate future performance.<br/>
Any modifications to your current mix of investments should be made gradually to lessen the impact of significant market changes and potential tax effects.<br/>
The Risk Profile Questionnaire is intended to provide guidelines to help you design a savings and investment program. It doesn't provide comprehensive investment advice, such as advice on buying a specific stock or bond and shouldn't be considered the sole or primary basis on which you make investment decisions. You may wish to consult a professional investment advisor, accountant, attorney, or broker before making an investment.<br/>
Your financial projections greatly depend on your assumptions, especially for inflation rate, investment expenses, taxes, and investment return. It's difficult to forecast such rates and returns accurately, especially over long periods. Therefore, it's critical that you update your projections periodically to accommodate any changes in your assumptions.<br/>
The longer your time horizon, the more likely any change in your assumptions will have a significant impact on your results. Even small changes can lead to substantial variations in results over time. A 1% change in your investment return can have a significant impact on your ability to meet your retirement goals over the long term.<br/>
Financial projections aren't mistake-proof and can't ensure specific future results. Changes in tax or benefit laws, investment markets, or your own financial situation can cause actual results to deviate substantially from your projection. To address this uncertainty, you should create several scenarios, with various sets of assumptions, to evaluate a wide range of possible outcomes.<br/>
The Risk Profile Questionnaire doesn't provide comprehensive investment advice. It's important to revise your financial profile periodically based on your experience and changing goals.<br/>

                                 </div>
                             
                              </div>
                              </div>
                          
                           
                              
                        </div>
                     </div>

                        */}
                  
               </Modal.Body>
            </Modal>






    </>
			


  
      );
    }
    }


